<div class="container">

  <app-header-dialog [iconName]="'monetization_on'">
    Anotação
  </app-header-dialog>



  <div class='content'>

    <form name="annotationForm" [formGroup]='annotationForm' autocomplete="off">

      <div style="display: flex; flex-direction: row; justify-content: space-between;">

        <mat-form-field class="date-width" appearance="outline">
          <mat-label>Data</mat-label>
          <input matInput [matDatepicker]="pickerDate" [errorStateMatcher]="matcher"
            [formControl]="annotationForm.controls.date">
          <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
          <mat-datepicker #pickerDate></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="situation-width" appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [errorStateMatcher]="matcher" [formControl]="annotationForm.controls.status">
            <mat-option *ngFor="let status of statusList" [value]="status.value">
              {{ status.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="annotationForm.controls.status.hasError('required')">
            A Situação é obrigatória
          </mat-error>
        </mat-form-field>

      </div>

      <mat-form-field class='full-width' appearance="outline">
        <mat-label>Texto</mat-label>
        <textarea class='text-area' matInput [errorStateMatcher]="matcher" [formControl]="annotationForm.controls.text"
          autocomplete="off">
            </textarea>
      </mat-form-field>

    </form>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button [disabled]='annotationForm.invalid' mat-raised-button
      (click)="matDialogRef.close([ 'add', annotationForm ])" *ngIf="!isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

    <button [disabled]='annotationForm.invalid' mat-raised-button
      (click)="matDialogRef.close([ 'edit', annotationForm ])" *ngIf="isEdit">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>